import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Controller } from 'react-hook-form';
import { requiredValidation } from 'validators';
import { Autocomplete, Callout, Column, ConfirmationModal, Spinner, Typography, getOptionLabel, getOptionSelected } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { BillContactPicker } from '~/components/BillModal/GlobalBillModal/BillContactPicker/BillContactPicker';
import { ContactAgreementState } from '~/components/BillModal/GlobalBillModal/GlobalBillModal.utils';
import { useGlobalBillModal } from '~/components/BillModal/GlobalBillModal/hooks/useGlobalBillModal';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { useLocaleKeys } from '~/i18n';
import { GlobalBillModalOld } from '../GlobalBillModalOld/GlobalBillModalOld';
export const GetGlobalBillModalTID = (parentTestId)=>getTestIds(parentTestId);
const GlobalBillModalContent = (props)=>{
    const { GlobalBillModalTestIds } = useMemo(()=>GetGlobalBillModalTID(), []);
    const { t: globalBillModalTexts } = useLocaleKeys('components.globalBillModal');
    const { t: commonButtons } = useLocaleKeys('common.buttons');
    const { control, selectedContact, contactAgreementState, agreementOptions, hasAdHocOption, showAgreementSelector, isPrimaryButtonLoading, isAgreementsLoading, handleChangeContact, primaryButtonClick } = useGlobalBillModal({
        dismissModal: props.dismissModal
    });
    const renderAgreementsField = ()=>{
        if (isAgreementsLoading) {
            return /*#__PURE__*/ _jsx(Spinner, {
                size: 32,
                centerBoxHeight: 36,
                centeredInBox: true
            });
        }
        if (contactAgreementState === ContactAgreementState.NoSignedAgreement) {
            return /*#__PURE__*/ _jsxs(Callout, {
                testId: GlobalBillModalTestIds.NoAgreementCallout(),
                intent: "info",
                withBorder: true,
                children: [
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        weight: "bold",
                        children: globalBillModalTexts.noAgreementCalloutTitle()
                    }),
                    /*#__PURE__*/ _jsx(Typography, {
                        variant: "paragraph1",
                        children: globalBillModalTexts.noAgreementCalloutBody()
                    })
                ]
            });
        }
        if (!showAgreementSelector) {
            return null;
        }
        return /*#__PURE__*/ _jsx(Controller, {
            control: control,
            name: "selectedAgreement",
            rules: requiredValidation(true),
            render: (renderProps)=>/*#__PURE__*/ _jsx(Autocomplete, {
                    bi: {
                        name: 'agreement_selector'
                    },
                    selectOnFocus: true,
                    fullWidth: true,
                    mobile: {
                        renderAsCard: true
                    },
                    testId: GlobalBillModalTestIds.AgreementsSelector(),
                    textFieldProps: {
                        label: globalBillModalTexts.agreementLabel(),
                        placeholder: globalBillModalTexts.agreementOrAdHocPlaceholder(),
                        error: !!renderProps.fieldState.error
                    },
                    value: renderProps.field.value,
                    options: agreementOptions,
                    getOptionLabel: getOptionLabel,
                    getOptionSelected: getOptionSelected,
                    dividers: hasAdHocOption ? [
                        -1
                    ] : undefined,
                    onChange: (_, value)=>renderProps.field.onChange(value)
                })
        });
    };
    return /*#__PURE__*/ _jsx(ConfirmationModal, {
        title: globalBillModalTexts.title(),
        testId: GlobalBillModalTestIds.Root(),
        primaryButtonTestId: GlobalBillModalTestIds.ContinueButton(),
        textAlignCenter: false,
        onCloseButtonClick: props.dismissModal,
        primaryButtonLabel: commonButtons.continue(),
        secondaryButtonLabel: commonButtons.cancel(),
        onSecondaryButtonClick: props.dismissModal,
        primaryButtonLoading: isPrimaryButtonLoading,
        onPrimaryButtonClick: primaryButtonClick,
        bi: {
            primaryButton: {
                name: 'continue'
            },
            secondaryButton: {
                name: 'cancel'
            },
            closeButton: {
                name: 'close'
            }
        },
        content: /*#__PURE__*/ _jsx(Controller, {
            control: control,
            name: "selectedContactId",
            rules: requiredValidation(true),
            render: (renderProps)=>/*#__PURE__*/ _jsxs(Column, {
                    gap: 16,
                    testId: GlobalBillModalTestIds.ContentWrapper(),
                    children: [
                        /*#__PURE__*/ _jsx(BillContactPicker, {
                            disabled: isAgreementsLoading,
                            selectedContactId: renderProps.field.value,
                            error: !!renderProps.fieldState.error,
                            onChange: (value)=>{
                                renderProps.field.onChange(value);
                                handleChangeContact();
                            }
                        }),
                        selectedContact && renderAgreementsField()
                    ]
                })
        })
    });
};
export const GlobalBillModal = (props)=>{
    const { BILL_MODAL_V2 } = useFeatureFlags();
    if (!BILL_MODAL_V2) {
        return /*#__PURE__*/ _jsx(GlobalBillModalOld, _object_spread({}, props));
    }
    return /*#__PURE__*/ _jsx(GlobalBillModalContent, _object_spread({}, props));
};
